import React, { useContext, useCallback, useState } from 'react';
import * as PropTypes from 'prop-types';

import Autosuggest from 'ati-ui-react/components/Autosuggest';

import i18nStrings from './strings';
import { useLocalized } from 'utils/useLocalized';
import { useDebounce } from 'utils/useDebounce';
import styles from './styles.modules.scss';
import { DataContext, LocaleContext } from 'contexts';

const DirectionAutosuggest = ({title, error, value, onChange}) => {
    const strings = useLocalized(i18nStrings);
    const locale = useContext(LocaleContext);
    const { findCities } = useContext(DataContext);
    const [suggestions, setSuggestions] = useState(null);

    const handleChangeValue = useCallback((text) => onChange(text), [onChange]);

    const handleSuggestionsClearRequested = useCallback(() => setSuggestions(null), []);

    const handleCityChange = useCallback((event, {suggestion}) => onChange(suggestion.cityName, suggestion.id, suggestion.type, suggestion.countryId), [onChange]);

    const handleFindCitiesDebounce = useDebounce(300, useCallback((inputValue) => findCities(inputValue).then((s) => setSuggestions(s)), [findCities]));

    const handleCitiesRequest = useCallback(({value}) => {
        handleFindCitiesDebounce(value);
        return value || '';
    }, [handleFindCitiesDebounce]);

    return (
        <div className={styles['element']}>
            <div className={styles['title']}>
                {title}
            </div>
            <Autosuggest
                noFog
                errorDescription={error && strings.required}
                locale={locale}
                placeholder={title}
                searchProperty="text"
                suggestions={suggestions}
                value={value || ''}
                valueProperty="text"

                onChange={handleChangeValue}
                onSuggestionsClearRequested={handleSuggestionsClearRequested}
                onSuggestionSelected={handleCityChange}
                onSuggestionsFetchRequested={handleCitiesRequest}
            />
        </div>
    );
};

export default DirectionAutosuggest;

DirectionAutosuggest.propTypes = {
    error: PropTypes.bool,
    title: PropTypes.string,
    value: PropTypes.string,
    onChange: PropTypes.func
};
